import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Component for individual sidebar items
const SidebarItem = ({ path, iconClass, label }) => {
    const location = useLocation();
    const isActive = location.pathname === path;

    return (
        <li>
            <Link to={path} className={isActive ? 'mm-active' : ''}>
                <i className={`metismenu-icon bg-happy-itme ${iconClass}`}></i>{label}
            </Link>
        </li>
    );
};

export default SidebarItem;